import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@dm/core';
import { SmallPanelComponent } from './small-panel.component';



@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    declarations: [SmallPanelComponent],
    exports: [SmallPanelComponent],
})
export class SmallPanelModule { }
